import type { PiletEntries } from "piral-core";

import {
  apiUrl,
  initialUrl,
  performLogin,
  performLogout,
} from "@/config.codegen";
import type { UserEntity } from "@/providers/UserProvider";

export function makeApiUrl(path: string) {
  return `${apiUrl}${path}`;
}

export async function loadPilets(): Promise<PiletEntries> {
  const res = await fetch(makeApiUrl("/pilets"));
  return await res.json();
}

export interface InitialDTO {
  pilets: PiletEntries;
  user: UserEntity;
  app?: string;
  params?: any;
}

export async function loadInitial(data?: string): Promise<InitialDTO> {
  const url = data ? `${initialUrl}?data=${data}` : initialUrl;
  const res = await fetch(url);

  if (res.ok) {
    return await res.json();
  }

  throw new Error(
    `Failed to load initial data: ${res.status} ${res.statusText}`,
  );
}

export function loginWith(provider: string, redirectPath?: string) {
  performLogin(provider, redirectPath);
}

export function logout() {
  performLogout();
}

interface JobStatus {
  status: "pending" | "inprogress" | "failed" | "success";
  message?: string;
  duration: number;
}

export async function checkJobStatus(id: string): Promise<JobStatus> {
  const res = await fetch(makeApiUrl(`/job-status/${id}`));
  return await res.json();
}

export async function setupJobNotifier(id: string): Promise<void> {
  await fetch(makeApiUrl("/job-status/notify"), {
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
    body: JSON.stringify({ id }),
  });
}

export async function removeJobNotifier(id: string): Promise<void> {
  await fetch(makeApiUrl(`/job-status/notify/${id}`), {
    method: "DELETE",
  });
}
